import React from 'react';

const FILTERS = ['All', 'Pitchers', 'Position Players', '10-Day IL', '60-Day IL', 'Day-to-Day'];

const InjuryFilter = ({ active, onChange }) => (
  <div className="flex flex-wrap gap-1.5">
    {FILTERS.map(f => (
      <button
        key={f}
        onClick={() => onChange(f)}
        className={`text-[9px] font-bold uppercase tracking-widest px-2.5 py-1 border transition-colors ${
          active === f
            ? 'bg-[#658d71] border-[#a9c9b1] text-white'
            : 'border-[#658d71] text-[#a9c9b1] hover:border-[#a9c9b1] hover:text-white'
        }`}
      >
        {f}
      </button>
    ))}
  </div>
);

export default InjuryFilter;